var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "signUp" } }, [
    _c("div", { staticClass: "signUp-topbar" }, [
      _c("i", {
        attrs: { alt: "首页", dir: "前往首页" },
        on: { click: _vm.goHome }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "topbar-btn" }, [
        _c(
          "div",
          {
            staticClass: "changeLangBtn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.moreLang()
              }
            }
          },
          [
            _c("button", { staticClass: "text" }, [
              _vm._v("\n          " + _vm._s(_vm.$t("language")) + "\n        ")
            ]),
            _vm._v(" "),
            _c("em", { staticClass: "iconfont icon-een" }),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeLangBox,
                    expression: "changeLangBox"
                  }
                ],
                staticClass: "chooseLangUl"
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "chooseLangUlli",
                    on: {
                      click: function($event) {
                        _vm.setLanguage(item.id)
                      }
                    }
                  },
                  [
                    _c("button", { staticClass: "text" }, [
                      _vm._v(
                        "\n            " + _vm._s(item.name) + "\n            "
                      )
                    ])
                  ]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "toLogin btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.goLogin()
              }
            }
          },
          [
            _c("button", { staticClass: "text" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("homepage_button1")) +
                  "\n        "
              )
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "signUp-wrapper" }, [
      _c("div", { staticClass: "signUp" }, [
        _c("div", { staticClass: "signUp-title" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("signup_title")) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputItem firstName" }, [
          _c("span", { staticClass: "account" }, [
            _vm._v(_vm._s(_vm.$t("signup_txt2")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.signUpForm.name,
                expression: "signUpForm.name",
                modifiers: { trim: true }
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.signUpForm.name },
            on: {
              blur: [
                _vm.checkName,
                function($event) {
                  _vm.$forceUpdate()
                }
              ],
              focus: _vm.checkName1,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.signUpForm, "name", $event.target.value.trim())
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show2,
                  expression: "show2"
                }
              ],
              staticClass: "input-warning"
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("signup_note8")) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputItem grade" }, [
          _c("span", { staticClass: "account" }, [
            _vm._v(_vm._s(_vm.$t("signup_txt3")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "classGrade" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.signUpForm.grade,
                    expression: "signUpForm.grade"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.signUpForm,
                        "grade",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.checkGrade
                  ]
                }
              },
              [
                _c(
                  "option",
                  { staticStyle: { display: "none" }, attrs: { value: "" } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("signup_note9")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v(_vm._s(_vm.$t("grade0")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v(_vm._s(_vm.$t("grade1")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "2" } }, [
                  _vm._v(_vm._s(_vm.$t("grade2")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "3" } }, [
                  _vm._v(_vm._s(_vm.$t("grade3")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "4" } }, [
                  _vm._v(_vm._s(_vm.$t("grade4")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "5" } }, [
                  _vm._v(_vm._s(_vm.$t("grade5")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "6" } }, [
                  _vm._v(_vm._s(_vm.$t("grade6")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "7" } }, [
                  _vm._v(_vm._s(_vm.$t("grade7")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "8" } }, [
                  _vm._v(_vm._s(_vm.$t("grade8")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "9" } }, [
                  _vm._v(_vm._s(_vm.$t("grade9")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "10" } }, [
                  _vm._v(_vm._s(_vm.$t("grade10")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "11" } }, [
                  _vm._v(_vm._s(_vm.$t("grade11")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "12" } }, [
                  _vm._v(_vm._s(_vm.$t("grade12")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "13" } }, [
                  _vm._v(_vm._s(_vm.$t("grade13")))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show9,
                  expression: "show9"
                }
              ],
              staticClass: "input-warning"
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("signup_note10")) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inputItem schoolName" },
          [
            _c(
              "span",
              { staticClass: "account", staticStyle: { "z-index": "900" } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("schoolName")) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("el-autocomplete", {
              staticClass: "school_name",
              attrs: {
                "fetch-suggestions": _vm.querySearchAsync,
                "trigger-on-focus": false,
                placeholder: _vm.country == "china" ? "请输入" : " ",
                "value-key": "schoolCnName"
              },
              on: { select: _vm.changeSchool },
              model: {
                value: _vm.signUpForm.schoolCnName,
                callback: function($$v) {
                  _vm.$set(_vm.signUpForm, "schoolCnName", $$v)
                },
                expression: "signUpForm.schoolCnName"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "inputItem phone" }, [
          _vm.$i18n.locale == "zh"
            ? _c("span", { staticClass: "account" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("signup_txt9")) + "\n        "
                )
              ])
            : _c("span", { staticClass: "account" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("myaccount_txt5")) +
                    "\n        "
                )
              ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.signUpForm.phone,
                expression: "signUpForm.phone",
                modifiers: { trim: true }
              }
            ],
            attrs: { type: "text", dir: "ltr" },
            domProps: { value: _vm.signUpForm.phone },
            on: {
              blur: [
                _vm.checkphone,
                function($event) {
                  _vm.$forceUpdate()
                }
              ],
              focus: _vm.checkphone1,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.signUpForm, "phone", $event.target.value.trim())
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show6,
                  expression: "show6"
                }
              ],
              staticClass: "input-warning",
              domProps: { textContent: _vm._s(_vm.phoneText) }
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("signup_note14")) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputItem phoneAuth" }, [
          _c("span", { staticClass: "account" }, [
            _vm._v(_vm._s(_vm.$t("signup_txt10")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.signUpForm.phoneCode,
                expression: "signUpForm.phoneCode",
                modifiers: { trim: true }
              }
            ],
            staticStyle: { "padding-right": "118px", width: "203px" },
            attrs: { type: "text" },
            domProps: { value: _vm.signUpForm.phoneCode },
            on: {
              blur: [
                _vm.checkphoneCode,
                function($event) {
                  _vm.$forceUpdate()
                }
              ],
              focus: _vm.checkphoneCode1,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.signUpForm,
                  "phoneCode",
                  $event.target.value.trim()
                )
              }
            }
          }),
          _vm._v(" "),
          _c("button", {
            attrs: { id: "buttonMsg" },
            domProps: { textContent: _vm._s(_vm.getMsgtext) },
            on: { click: _vm.getMsg }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show7,
                  expression: "show7"
                }
              ],
              staticClass: "input-warning"
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("signup_note15")) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputItem password" }, [
          _c("span", { staticClass: "account" }, [
            _vm._v(_vm._s(_vm.$t("signin_txt2")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.signUpForm.password,
                expression: "signUpForm.password",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              autocomplete: "off",
              dir: "ltr",
              type: _vm.passwordSwitch === false ? "password" : "text"
            },
            domProps: { value: _vm.signUpForm.password },
            on: {
              blur: [
                _vm.checkpwd,
                function($event) {
                  _vm.$forceUpdate()
                }
              ],
              focus: _vm.checkpwd1,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.signUpForm, "password", $event.target.value.trim())
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "pwdSwitch", on: { click: _vm.showPwdSwitch } },
            [_c("i", { staticClass: "el-icon-view" })]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show4,
                  expression: "show4"
                }
              ],
              staticClass: "input-warning"
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("setPass_txt2")) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "signUp-btn", on: { click: _vm.submit } }, [
          _vm._v("\n        " + _vm._s(_vm.$t("signup_button")) + "\n      ")
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show11,
                expression: "show11"
              }
            ],
            staticClass: "signUp-warning",
            domProps: { textContent: _vm._s(_vm.warining) }
          },
          [_vm._v("\n        " + _vm._s(_vm.$t("signup_note16")) + "\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2020db48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2020db48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/signUp.vue
// module id = null
// module chunks = 